<template>
  <div class="row">
    <div class="col-md-6">
      <div class="card mb-25 border-0 rounded-0 bg-white add-product-box">
        <div class="card-header">
          <h5 class="mb-0">Informarion Client :</h5>
        </div>

        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <ul class="list-unstyled my-1">
            <li class="my-25">
              <span class="align-middle"
                ><b class="bclass">Magasin : </b>
                {{ note_BL?.client?.store }}</span
              >
            </li>
            <li class="my-25">
              <span class="align-middle"
                ><b class="bclass">Téléphone : </b>
                {{ note_BL?.client?.phone }}</span
              >
            </li>
            <li>
              <span class="align-middle">
                <b class="bclass">Client :</b>
                {{ note_BL?.note_customer_name }}</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card mb-25 border-0 rounded-0 bg-white add-product-box">
        <div class="card-header">
          <h5 class="mb-0">Information Bon livraison</h5>
        </div>

        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <ul class="list-unstyled my-1">
            <li>
              <span class="align-middle"
                ><b class="bclass">Bon de livraison :</b>
                {{ note_BL?.note_ref }}</span
              >
            </li>
            <li class="my-25">
              <span class="align-middle"
                ><b class="bclass">Date :</b>
                {{ getDate(note_BL?.created_at) }}</span
              >
            </li>
            <li>
              <span class="align-middle"
                ><b class="bclass">Colis :</b>
                {{ note_BL?.note_total_parcel }}</span
              >
            </li>
            <li>
              <span class="align-middle"
                ><b class="bclass">Total :</b> {{ note_BL?.crbt }} DH</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <hr />
    <div class="col-md-6">
      <!-- <label>Voir</label>
      <v-select
        v-model="filter.per_page"
        :options="[10, 25, 50]"
        :clearable="false"
        @input="showDetails()"
      />
      <label>sur {{ filter.total }} entité </label> -->
    </div>
    <div class="col-md-6">
      <div class="custom-search d-flex justify-content-end">
        <div class="form-group">
          <div class="d-flex align-items-center">
            <input
              v-model="filter.searchTerm"
              placeholder="chercher"
              @change="showDetails()"
              type="text"
              class="form-control"
              @input="handleInput"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <vue-good-table :columns="columnsBL" :rows="colisBL">
    <template #table-row="props">
      <span v-if="props.column.field === 'num'" class="text-nowrap">
        <span class="text-nowrap">{{ props.row.originalIndex + 1 }}</span>
      </span>

      <template v-else-if="props.column.field === 'code'">
        <b>{{ props.row.code }}</b>
      </template>

      <span v-else-if="props.column.field === 'status'">
        <span
          v-if="props.row.status == 'IN_PROGRESS'"
          class="rounded-pill fs-13 badge text-bg-black custom-badge"
          :style="{
            '--dynamic-bg': globalStore.globalHelper(props.row.status_second)
              .code_color,
          }"
        >
          {{ globalStore.globalHelper(props.row.status_second).name }}
        </span>
        <span
          v-else
          class="rounded-pill fs-13 badge text-bg-black custom-badge"
          :style="{ '--dynamic-bg': props.row.code_color }"
        >
          {{ props.row.s_name }}
        </span>
      </span>
      <span v-else-if="props.column.field === 'price'">
        <b>Adresse : </b> {{ props.row.address }}<br />
        <b>Destinataire : </b> {{ props.row.receiver }}<br />
      </span>

      <span v-else-if="props.column.field === 'info'">
        {{ props.row.price }} DH
      </span>

      <span v-else-if="props.column.field === 'actions' && type_e == true">
        <buttonn
          v-if="
            props.row.status == 'WAITING_PICKUP' &&
            props.row.reception_note == 0
          "
          variant="danger"
          class="btn-icon"
          @click="removeColisBL(props.row.id_colis, noteBL)"
        >
          <feather-icon icon="TrashIcon" />
        </buttonn>
      </span>

      <span v-else>
        {{ props.formattedRow[props.column.field] }}
      </span>
    </template>
  </vue-good-table>

  <div class="d-flex justify-content-end mb-2">
    <span class="fs-5">
      <strong>Total :</strong> {{ totalPriceBL.toFixed(2) }} DH
    </span>
  </div>

  <div class="row">
    <div class="col-md-6"></div>
    <div class="col-md-6">
      <PaginatorContent
        :pagination="filter"
        @paginate="showDetails"
        :offset="9"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { computed, reactive, ref, watch } from "vue";
import { defineComponent } from "vue";
import { useGlobalStore } from "@/stores/global";
import { onMounted } from "vue";

export default defineComponent({
  props: {
    noteBL: {
      type: Object,
      required: true,
    },
    getRecords: {
      type: Function,
    },
    type: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
  },
  setup(props) {
    const { showToast } = useAppToast();

    const note_BL = ref(props.noteBL);
    const colisBL = ref([]);

    const globalStore = useGlobalStore();

    const columnsBL = [
      {
        label: "N°",
        field: "num",
      },
      {
        label: "Code denvoi",
        field: "code",
      },
      {
        label: "Téléphone",
        field: "phone",
      },
      {
        label: "Ville",
        field: "city_name",
      },
      {
        label: "Informations",
        field: "info",
      },
      {
        label: "Status",
        field: "status",
      },
      {
        label: "Crbt",
        field: "price",
      },
      {
        label: "Action",
        field: "actions",
      },
    ];

    const filter = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    async function removeColisBL(colis, BL) {
      let data = new FormData();
      data.append("colis_id", colis);

      const result = await Swal.fire({
        text: "Vous voulez supprimer le colis ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.post(`/api/auth/RemoveColisBL`, data);

          if (res.data.message === "success") {
            showDetails();
            props.getRecords();
            showToast("Colis est bien supprimé", "success");
          } else if (res.data.message === "Issaved") {
            showToast("Vous pouvez pas le supprimer!", "error");
          } else if (res.data.message === "error note") {
            showToast("Vous pouvez pas le supprimer de ce bon", "error");
          } else if (res.data.message === "error parcel") {
            showToast(
              "Vous pouvez pas supprimer ce colis, Existe déjà dans un bon de reception!",
              "error"
            );
          } else {
            showToast("Something went wrong! Please try again", "error");
          }
        } catch (err) {
          showToast("Erreur de connexion au serveur", "error");
        }
      }
    }

    function getDate(value) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }
    async function showDetails(page = 1) {
      try {
        filter.current_page = page;
        const res = await api.get(
          `/api/auth/delivery_note_show/${note_BL.value.id}?searchTerm=${filter.searchTerm}&page=${filter.current_page}&per_page=${filter.per_page}`
        );

        // Update colisBL with response data
        colisBL.value = res.data.users.data;

        // Merge pagination/filter info safely
        Object.assign(filter, {
          current_page: res.data.users.current_page,
          per_page: res.data.users.per_page,
          total: res.data.users.total,
          last_page: res.data.users.last_page,
        });

        // Optional: you can track count directly if needed
        // count.value = colisBL.value.length;
      } catch (error) {
        console.error("Error fetching delivery note details:", error);
        showToast(
          "Une erreur est survenue lors du chargement des colis",
          "error"
        );
      }
    }

    function handleInput() {
      //   // Clear previous debounce timer
      //   clearTimeout(debounceTimer);

      //   // Set a new debounce timer
      //   debounceTimer = setTimeout(() => {
      //     if (!searchTerm || searchTerm === '') {
      //       users1.searchTerm = searchTerm
      //       showDetails()
      //     } else if (searchTerm && searchTerm.length > 4) {
      //       users1.searchTerm = searchTerm
      //       showDetails()
      //     }
      //   }, 500); // Adjust the delay (in milliseconds) as needed
      showDetails();
    }

    onMounted(() => {
      console.log("open", props);
      if (props.isOpen) {
        showDetails();
      }
    });

    
    const totalPriceBL = computed(() => {
      return colisBL.value.reduce((sum, row) => {
        return sum + Number(row.price || 0);
      }, 0);
    });

    watch(
      () => props.noteBL,
      (newVal) => {
        if (newVal && Object.keys(newVal).length > 0) {
          console.log("noteBL updated:", newVal);
          showDetails();
        }
      },
      { immediate: true }
    );

    return {
      note_BL,
      fetchRecords: props.getRecords,
      type_e: props.type,
      columnsBL,
      filter,
      colisBL,
      showDetails,
      removeColisBL,
      handleInput,
      getDate,
      globalStore,
      totalPriceBL
      
    };
  },
});
</script>
